export const BASE_CURRENCY = `GBP`;
export const RATES_URL = `https://api.ratesapi.io/api/latest?base=${BASE_CURRENCY}`;
export const LOCAL_SETTINGS = `settings`;
